import React, { useLayoutEffect, useMemo } from 'react';
import { Empty } from 'antd';
import {
  useCompaniesQuery,
  companiesSelectors,
} from '../../../../api/companies';
import {
  useSearchParamsMethods,
  useSearchParamsSelector,
} from '../../../../shared/packages/searchParamsManager';
import {
  searchParamKeys,
  searchParamSelectors,
} from '../../../../shared/configs/searchParams';
import BaseError from '../../../../../../components/BaseError';

const paramName = searchParamKeys.company;

const ValidateSelectedCompany = ({ children }) => {
  const { data } = useCompaniesQuery({
    options: { select: companiesSelectors.toStringIds },
  });

  const currentCompanyId = useSearchParamsSelector(
    searchParamSelectors[paramName]
  );

  const { setParams } = useSearchParamsMethods();

  const notSelected = currentCompanyId == null;

  useLayoutEffect(() => {
    if (notSelected && Array.isArray(data) && data?.length === 1) {
      setParams({ [paramName]: data[0].id });
    }
  }, [notSelected, data, setParams]);

  const isValid = useMemo(
    () => (notSelected ? undefined : data?.has(currentCompanyId)),
    [data, notSelected, currentCompanyId]
  );

  if (notSelected) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="Выберите компанию"
      />
    );
  }

  if (isValid === false) {
    return <BaseError description={createDescription()} />;
  }

  if (isValid === true) {
    return children;
  }

  return null;
};

export default ValidateSelectedCompany;

function createDescription() {
  return (
    <>
      Выбранная компания отсутствует в списке доступных компаний
      <br />
      Выберите другую компанию из списка
    </>
  );
}
